import { IDeliveryAddress, IObject } from "@/types/common-types";
import AddAddressIcon from "../svg/AddAddressIcon";
import { prefix } from ".";
import NoAddressIcon from "../svg/NoAddressIcon";
import { Button, DropdownMenu, Input } from 'react-vant'
import AddressSearch from "./AddressSearch";
import ChooseIcon from "../svg/ChooseIcon";
import ChoosedIcon from "../svg/ChoosedIcon";
import EditAddressIcon from "../svg/EditAddressIcon";
import { useState } from "react";
import { Constants } from "@/constants";
import { setLocalStorageJson } from "@/utils";
import PhoneNumber from "../PhoneNumber";
import { trim } from "lodash";
import { TFunction } from "i18next";


interface ICustomizedProps {
  value?: string;
  t: TFunction<"common", undefined>;
  onClick?: () => void;
  onChange?: (value: string) => void;
};

const AddressInput: React.FC<ICustomizedProps> = (props) => {
  const { value, onClick, t } = props;

  return (
    <div onClick={onClick} className={`${prefix}-input ${value ? '' : 'placeholder'}`}>{value || t('addressLabelPlaceholder')}</div>
  )
};

interface IDeliveryProcessProps {
  addressList: IDeliveryAddress[];
  showForm: boolean;
  showSearch: boolean;
  isUpdate: boolean;
  t: TFunction<"common", undefined>;
  setTitle: (value: string) => void;
  setShowTabs: (value: boolean) => void;
  setShowForm: (value: boolean) => void;
  setShowSearch: (value: boolean) => void;
  setIsUpdate: (value: boolean) => void;
  setAddressList: (record: IDeliveryAddress[]) => void;
  onConfirm: (option?: any) => void;
  handleChangeAddress: (index: number) => void;
};

const DeliveryProcess: React.FC<IDeliveryProcessProps> = (props) => {
  const {
    t,
    addressList,
    showSearch,
    showForm,
    isUpdate,
    setTitle,
    setShowTabs,
    setShowForm,
    setShowSearch,
    onConfirm,
    setIsUpdate,
    setAddressList,
    handleChangeAddress
  } = props;

  const [editIndex, setEditIndex] = useState<number>(-1);
  const [latValue, setLatValue] = useState<string>('');
  const [lngValue, setLngValue] = useState<string>('');
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [record, setRecord] = useState<IObject>({});

  const handleFormConfirm = () => {
    const newValues: any = {
      ...record,
      area: record.area?.key || 'Hong Kong Island',
      lat: latValue,
      lng: lngValue,
    };

    if (isUpdate) {
      setShowForm(false);
      if (addressList[editIndex]) {
        const newList = [...addressList];
        newList[editIndex] = newValues;
        setAddressList(newList);
        setLocalStorageJson(Constants.DELIVERY_ADDRESS, newList);
        setIsUpdate(false);
      }
    } else {
      if (!showForm) {
        onConfirm()
      } else {
        onConfirm(newValues);
      }
    }
  };

  const handleAddressChange = (value: string, lat: string, lng: string) => {
    setShowSearch(false);
    setLatValue(lat);
    setLngValue(lng);
    const newRecord = { ...record };
    newRecord['address'] = value;
    setRecord(newRecord);
    setDisabled(true);
  };

  const handleEdit = (record: IDeliveryAddress, index: number) => {
    handleScrollTop();
    setIsUpdate(true);
    setShowForm(true);
    setShowTabs(false)
    setEditIndex(index);
    setRecord({
      ...record,
      'area': {
        key: record.area || 'Hong Kong Island'
      }
    })
    setDisabled(false);
  };

  const handleNew = () => {
    handleScrollTop();
    setRecord({
      'area': {
        key: 'Hong Kong Island'
      }
    });
    setTitle(t('addNewAddress'));
    setShowForm(true);
    setShowTabs(false);
  };

  const handleConfirm = () => {
    handleChangeAddress(selectedIndex);
    onConfirm();
    setTimeout(() => {
      setSelectedIndex(0);
    }, 100);
  };

  const handleValuesChange = (key: string, value: any) => {
    const requiredKeys = ['name', 'phone', 'address', 'street'];
    let pass = true;

    const newRecord = { ...record };
    newRecord[key] = value;

    for (let i = 0; i < requiredKeys.length; i++) {
      const itemKey = requiredKeys[i];
      const value = newRecord[itemKey];
      if (!value || trim(value).length < 1) {
        pass = false;
        break;
      }

      if (itemKey === 'phone') {
        const inputValue = value.substring(value.indexOf(' ') + 1);
        const dialCode = value.substring(0, value.indexOf(' ')).replace('+', '');

        if (!inputValue || !dialCode || !trim(inputValue)) {
          pass = false;
          break;
        }
      }
    }

    setRecord(newRecord);
    setDisabled(!pass);
  };

  const options = [
    {
      value: 'Hong Kong Island',
      text: 'Hong Kong Island',
    },
    {
      value: 'Kowloon',
      text: 'Kowloon',
    },
    {
      value: 'New Territories',
      text: 'New Territories',
    },
    {
      value: 'Other',
      text: 'Other',
    },
  ];

  const handleScrollTop = () => {
    const doc = document.getElementById('deliveryContent');
    if (doc) {
      doc.scrollTo({top: 0})
    }
  }

  return (
    <div className={`${prefix}-delivery`}>
      <div id="deliveryContent" className={`${prefix}-delivery-content`}>
        {
          !showForm &&
          <>
            {
              addressList.length > 0 &&
              <div className={`${prefix}-delivery-list`}>
                {
                  addressList.map((item, index) => (
                    <div key={`${item.name}-${index}`} className={`${prefix}-delivery-list-item`}>
                      <div className={`${prefix}-delivery-list-item-details`}>
                        <div>{item.name}</div>
                        <div>{item.phone}</div>
                        <div>{item.address}</div>
                        <div>{item.street}</div>
                      </div>
                      <div className={`${prefix}-delivery-list-item-actions`}>
                        <div onClick={() => setSelectedIndex(index)}>{index === selectedIndex ? <ChoosedIcon /> : <ChooseIcon />}</div>
                        <EditAddressIcon onClick={() => handleEdit(item, index)} />
                      </div>
                    </div>
                  ))
                }
              </div>
            }
            <div className={`${prefix}-delivery-add`} onClick={handleNew}>
              <AddAddressIcon className={`${prefix}-delivery-add-icon`} />
              <div>{t('addAddress')}</div>
            </div>
            {
              addressList.length < 1 &&
              <div className={`${prefix}-delivery-noData`}>
                <NoAddressIcon />
                <div className="tips">{t('noAddressTips')}</div>
              </div>
            }
            <Button onClick={handleConfirm} type='primary'>{t('confirm')}</Button>
          </>
        }
        {
          showForm &&
          <>
            {
              !showSearch &&
              <>
                <div className={`${prefix}-delivery-form`}>
                  <div className={`${prefix}-delivery-form-item`}>
                    <label className="label">
                      <span>{t('receiverName')}</span>
                      <span>*</span>
                    </label>
                    <Input onChange={(value) => handleValuesChange('name', value)} value={record.name} placeholder={t('receiverNamePlaceholder')} />
                  </div>
                  <div className={`${prefix}-delivery-form-item`}>
                    <label className="label">
                      <span>{t('phoneNumber')}</span>
                      <span>*</span>
                    </label>
                    <PhoneNumber onChange={(value) => handleValuesChange('phone', value)} value={record.phone} />
                  </div>
                  <div className={`${prefix}-delivery-form-item`}>
                    <label className="label">
                      <span>{t('addressLabel')}</span>
                      <span>*</span>
                    </label>
                    <AddressInput t={t} value={record.address} onClick={() => setShowSearch(true)} />
                  </div>
                  <div className={`${prefix}-delivery-form-item`}>
                    <label className="label">
                      <span>{t('street')}</span>
                      <span>*</span>
                    </label>
                    <Input onChange={(value) => handleValuesChange('street', value)} value={record.street} placeholder={t('addressLabelPlaceholder')} />
                  </div>
                  <div className={`${prefix}-delivery-form-item`}>
                    <label className="label">
                      <span>{t('area')}</span>
                      <span>*</span>
                    </label>
                    {/* <div className={`${prefix}-input`}>Hong Kong Island</div> */}
                    <DropdownMenu
                      direction='up'
                      className={`${prefix}-delivery-form-item-area`}
                      value={record.area}
                      onChange={(value) => handleValuesChange('area', value)}
                    >
                      <DropdownMenu.Item name="key" placeholder={t('please_select')} options={options} />
                    </DropdownMenu>
                  </div>
                  <div className={`${prefix}-delivery-form-item`}>
                    <label className="label">{t('deliveryNote')}</label>
                    <Input onChange={(value) => handleValuesChange('note', value)} value={record.note} placeholder={t('deliveryNotePlaceholder')} />
                  </div>
                </div>
                <Button onClick={handleFormConfirm} disabled={disabled} nativeType='submit' type='primary'>{t('confirm')}</Button>
              </>
            }
            {
              showSearch &&
              <AddressSearch
                t={t}
                onChange={handleAddressChange}
              />
            }
          </>
        }
      </div>
    </div>
  )
};

export default DeliveryProcess;